import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from "react-redux";
import '../../../assets/stylesheets/ClubSlide/NewTable.scss';
import { useParams, useHistory } from 'react-router-dom';
import Header from '../../Units/Header';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import { requestCreateTable } from "../../../store/actionCreators/table";
import { openDialog } from '../../../store/actionCreators/dialog';
import Select from 'react-select';
import dropdownStyles from "../../../config/customStyles";
import parameters from "../../../config/parameters";
import configs from "../../../config/config";

const customStyles = dropdownStyles.feeSelectorStyles;

const Range = Slider.Range;
const playersPerTable = {
    nlh: [6, 9],
    plo4: [6, 9],
    plo5: [6, 9],
    capado: [6]
};
const sbValues = parameters.smallBlinds;
const operationSequence = ['concurrent', 'sequential'];
const feeOptions = [{ value: '8', label: '8%' }, { value: '7', label: '7%' }, { value: '6', label: '6%' }, { value: '5', label: '5%' }, { value: '3', label: '3%' }];
const capOptions = [{ value: '0', label: 'No cap' }, { value: '20', label: '20BBs' }, { value: '10', label: '10BBs' }, { value: '5', label: '5BBs' }, { value: '4', label: '4BBs' }, { value: '3', label: '3BBs' }, { value: '2', label: '2BBs' }];
const options = configs.createTable.options;
const ploGameTypes = ['plo4', 'plo5', 'capado'];
;

const TableParams = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { type } = props.location;

    const durationTitles = {
        0: `1 ${t('day')}`,
        1: `1 ${t('week')}`,
        2: `1 ${t('month')}`
    };
    const [tableParams, setTableParams] = useState({
        gameType: parameters.gameTypes[type === 'plo' ? ploGameTypes[0] : type],
        numberOfSeats: 6,
        actionTime: 15,
        smallBlind: 4,
        buyin: [50, 200],
        duration: 1,
        sequence: 'concurrent',
        autoStart: true,
        autoStartMinPlayers: 2,
        callTime: true,
        times: 12,
        insurance: false,
        fee: feeOptions[0],
        cap: capOptions[0],
        byh: false,
        gpsRestriction: false,
        ipRestriction: false
    });

    const dispatch = useDispatch();
    const { id: clubId } = useParams();
    const [isTableNameValid, setIsTableNameValid] = useState(true);
    const inputRef = useRef();

    const setParam = (e, { param }) => {
        setTableParams({
            ...tableParams,
            [param]: e
        });
    };

    const handleChange = (e) => {
        e.persist();
        setTableParams({
            ...tableParams,
            [e.target.name]:
                e.target.type === 'checkbox'
                    ? e.target.checked
                    : e.target.value,
        });
    };


    const createTable = useCallback(() => {
        if (!tableParams.tableName.replace(/\s/g, '')) {
            setIsTableNameValid(false);
            inputRef && inputRef.current.focus();
        } else {
            setIsTableNameValid(true)
            dispatch(requestCreateTable({ params: tableParams, history }));
        }
    }, [tableParams]);

    const expandInfo = (item) => {
        if (item === 'byh') dispatch(openDialog('betYourHand', { type: type }));
    }

    return (
        <div className={`createNewTable`}>
            <Header title={type} backTo={`/club/${clubId}/createTable`} />
            <input className={`tableName ${!isTableNameValid && 'error'}`} placeholder={t('nameOfTable')}
                onChange={handleChange}
                name={`tableName`}
                value={tableParams.tableName || ''}
                ref={inputRef}
            />
            {!isTableNameValid && <p className={`invalidTableName`}>{t('error.invalidTableName')}</p>}
            <div className={`playerCountContainer`} >
                {playersPerTable[parameters.gameTypeTitles[tableParams.gameType].toLowerCase()].map((count) =>
                    (<div key={count} className={`playerCount _${type}`}>
                        <input type="radio" id={count} value={count} checked={count == tableParams.numberOfSeats}
                            onChange={handleChange} name={`numberOfSeats`} />
                        <label htmlFor={count}>{count}</label>
                    </div>)
                )
                }
            </div>
            {type === 'plo' &&
                <React.Fragment>
                    <div className={`gameTypeContainer`}>
                        {ploGameTypes.map(type => (
                            (<div key={type} className={`gameTypeItem ${parameters.gameTypes[type] == tableParams.gameType && "selected"}`}>
                                <input type="radio" id={type} value={parameters.gameTypes[type]} onChange={handleChange} name={`gameType`} />
                                <label htmlFor={type}>{t(type)}</label>
                            </div>)
                        ))}
                    </div>
                </React.Fragment>
            }
            <div className="actionTime">
                {`${t('actionTime')}:`}
                {[15, 20, 30].map((time) =>
                    (<div key={time} className="timeOption">
                        <input type="radio" id={time} value={time} checked={time == tableParams.actionTime} onChange={handleChange} name={`actionTime`} />
                        <label htmlFor={time}>{time}s</label>
                    </div>)
                )}
            </div>
            <div className={`sliderContainer`} >
                {t('blinds')}: {sbValues[tableParams.smallBlind]} / {sbValues[tableParams.smallBlind] * 2}
                <div>
                    <input type="range" min="0" step='1' multiple max={`${sbValues.length - 1}`} value={tableParams.smallBlind}
                        onChange={handleChange} className={`slider`} name="smallBlind"
                    />
                </div>
            </div>
            <div className={`buyin`}>
                <span>{`${t('buyInSliderName')}:`}</span>
                <span>{tableParams.buyin[0]}BB</span>
                <span>{tableParams.buyin[1]}BB</span>
            </div>
            <div className={`buyin`}>
                <span>{`${t('min')}: 20BB`}</span>
                <span>{`${t('max')}: 500BB`}</span>
            </div>
            <Range
                min={20}
                max={500}
                allowCross={false}
                defaultValue={[tableParams.buyin[0], tableParams.buyin[1]]}
                count={1}
                step={10}
                pushable={true}
                name="buyin"
                onChange={e => setParam(e, { param: 'buyin' })}
            />
            <div className={`${type}Sequence`}>
                <div className={`operationSequenceText`}>{t('operationSequence')}:</div>
                <div className={`operationSequence`}>
                    {operationSequence.map(item =>
                        (<div key={item}>
                            <input type="radio" id={item} value={item} checked={item == tableParams.sequence} onChange={handleChange} name={`sequence`} />
                            <label htmlFor={item}>{t(item)}</label>
                        </div>)
                    )}
                </div>
            </div>
            {configs.createTable.insurance &&
                <div className={`riskManagementContainer _${type}`}>
                    {t('riskManagement')}:
                    <div className={`riskManagement`}>
                        <label className={`checkboxContainer insurance _${type}`} >
                            <input type="checkbox" name={'insurance'} checked={tableParams.insurance} onChange={handleChange} />
                            <span className="checkmark"></span>
                            <span className="label-text">{t('insurance')}</span>
                        </label>
                    </div>
                </div>
            }
            <div className={`selectors`}>
                <div>
                    <span>{t('fee')}</span>
                    <Select options={feeOptions} onChange={e => setParam(e, { param: 'fee' })} defaultValue={feeOptions[0]} styles={customStyles} isSearchable={false} />
                </div>
                <div className={`cap`}>
                    <span>{t('cap')}</span>
                    <Select options={capOptions} onChange={e => setParam(e, { param: 'cap' })} defaultValue={capOptions[0]} styles={customStyles} isSearchable={false} />
                </div>
            </div>
            <div className={`tableCostAndBalance _${type}`}>
                {['tableCost', 'balance'].map((item) => (
                    <div className={item} key={item}>
                        <div>{t(item)}: </div>
                        <div className={`sapphireIcon`}>0</div>
                    </div>
                ))}
            </div>
            {options.length > 0 &&
                <div className={`borderTop`}>
                    {options.map((item) => (
                        <div className={`switchBox ${item} _${type}`} key={item}>
                            <label className={`checkboxContainer`}>
                                <input type={`checkbox`} id={item} value={tableParams.item} defaultChecked={tableParams.item} onChange={handleChange} name={item} />
                                <span className={`checkmark`}></span>
                                {t(item)}
                                <button className="infoButton" onClick={() => expandInfo(item)}></button>
                            </label>
                        </div>
                    ))}
                </div>
            }

            <div className={`duration`}>
                <Slider
                    min={0}
                    max={2}
                    step={1}
                    defaultValue={tableParams.duration}
                    marks={durationTitles}
                    onChange={e => setParam(e, { param: 'duration' })}
                />
            </div>
            <div className={`dialogConfirmBox`}>
                <button className={`tertiary`}>{t('button.save')}</button>
                <button className="primary" disabled={!tableParams.tableName} onClick={createTable}>{t('button.create')}</button>
            </div>
        </div>
    );
};

export default TableParams;
